import React, { FC, useEffect, useRef } from 'react';
import {
  Dropdown,
  InlineErrorMessage,
  Typography,
  Sizes,
  TextBoldness,
  getClassNameFactory,
} from '@dcl/ui';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { IDropDownSelectorProps } from '../../types';
import './DropDownSelector.css';

export const DropDownSelector: FC<IDropDownSelectorProps> = (props) => {
  const {
    dropdownList,
    placeholderText,
    errorMessageText,
    dropdownLabel,
    showErrorMessage,
    onDropdownValueChange,
    isDisabled,
    maximumVisibleItem,
    dropdownValue,
    id,
  } = props;
  const dropDownRef = useRef<Dropdown>();
  const getClassName = getClassNameFactory(DropDownSelector.displayName);

  useEffect(() => {
    dropDownRef?.current?.setState({ value: dropdownValue });
  }, [dropdownValue]);

  const customDropdown = getClassName({ descendantName: 'customDropdown' });
  const dropdownDisable =
    isDisabled && getClassName({ descendantName: 'dropdownDisable' });
  const errorMessage =
    showErrorMessage && getClassName({ descendantName: 'errorMessage' });

  useEffect(() => {
    const dropDown = document.getElementsByClassName(
      dropdownLabel.replace(/ /g, '-')
    );

    dropDown[0].id = `dropdown-${dropdownLabel}`;
  }, [dropdownLabel]);

  return (
    <div>
      <label htmlFor={`dropdown-${dropdownLabel}`}>
        <Typography
          type={Sizes.XXTRASMALL}
          boldness={TextBoldness.Medium}
          tag={TypographyTags.P}
          className={getClassName({ descendantName: 'dropDownLabel' })}
        >
          {dropdownLabel}
        </Typography>
      </label>

      <Dropdown
        id={`dropdown-${dropdownLabel}`}
        ref={(el) => (dropDownRef.current = el!)}
        maxVisibleItems={maximumVisibleItem}
        block={true}
        placeholder={placeholderText}
        onValueChanged={(value) => onDropdownValueChange(value as string)}
        withCheckmark
        className={`${customDropdown} ${dropdownDisable} ${errorMessage} ${String(
          dropdownLabel
        ).replace(/ /g, '-')}`}
        value={dropdownValue}
        items={dropdownList}
      />
      <div className={getClassName({ descendantName: 'error' })}>
        {showErrorMessage && (
          <InlineErrorMessage
            data-testid="validation-error"
            errorMessage={errorMessageText}
            id={`validationError-${id}`}
          />
        )}
      </div>
    </div>
  );
};

DropDownSelector.displayName = 'DropDownSelector';
